/**
 * Metadata constants that don't require API fetching
 */

export const GENDER_OPTIONS = ['Male', 'Female', 'Nonbinary'] as const;

export type Gender = typeof GENDER_OPTIONS[number];

